import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, roles }) {
    const { user } = useAuth();
    if (user === undefined) {
        return (
            <div className="min-h-screen grid place-items-center" data-testid="loading">
                <div className="text-sm text-stone-500">Loading…</div>
            </div>
        );
    }
    if (user === null) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role) && user.role !== "founder") {
        return (
            <div className="p-8" data-testid="no-access">
                <div className="font-serif text-2xl">No access</div>
                <div className="text-stone-500 mt-2">
                    This section is restricted to: {roles.join(", ")}.
                </div>
            </div>
        );
    }
    return children;
}
